import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = [
    'codeSentContainer',
    'error',
    'form',
    'otpCode',
    'otpItem',
    'resendOtpForm',
    'spinner'
  ];

  declare errorTarget: HTMLElement;
  declare codeSentContainerTarget: HTMLElement;
  declare currentFocusedValue: string;
  declare formTarget: HTMLFormElement;
  declare otpCodeTarget: HTMLInputElement;
  declare otpItemTargets: HTMLInputElement[];
  declare resendOtpFormTarget: HTMLFormElement;
  declare spinnerTarget: HTMLElement;

  private verificationCode: string[] = [];

  validate = (input: string) => {
    // accept numbers only
    return /^\d+$/.test(input);
  };

  clearError = (input) => {
    if (input.classList.contains('error')) {
      this.otpItemTargets.forEach((otpItem) => {
        otpItem.setAttribute('class', 'elc-iam-verification-code-item default');
        this.errorTarget.classList.add('hidden');
      });
    }
  };

  onFocus = (event) => {
    event.target.select();
    this.currentFocusedValue = event.target.value;

    this.clearError(event.target);
  };

  handleInput(event) {
    const input = event.target;
    const eventValue = input.value;
    const value = eventValue.replace(this.currentFocusedValue, '');
    const index = Number(input.dataset.index);

    if (this.validate(value)) {
      input.value = value;
      this.verificationCode[index] = value;

      const verificationCode = this.verificationCode.join('');
      const isCompleted = verificationCode.length === this.otpItemTargets.length;

      if (isCompleted) {
        this.verifyOtp(verificationCode);
        input.blur();

        return;
      }

      this.otpItemTargets[index + 1].focus();
    } else {
      input.value = this.currentFocusedValue;
      input.select();

      // move focus forward when same number typed
      if (value === '') {
        this.otpItemTargets[index + 1].focus();
      }
    }
  }

  onInputPaste = (event) => {
    event.preventDefault();

    if (event.clipboardData) {
      const pastedValue = event.clipboardData.getData('text');
      const values = pastedValue.slice(0, this.otpItemTargets.length);

      if (!this.validate(values)) {
        return;
      }

      this.otpItemTargets.forEach((input, index) => {
        const value = values[index] ?? '';

        input.value = value;
        this.verificationCode[index] = value;
      });

      const isCompleted = values.length === this.otpItemTargets.length;

      if (isCompleted) {
        this.verifyOtp(values);
        this.otpItemTargets[event.target.dataset.index].blur();

        return;
      }

      this.otpItemTargets[pastedValue.length].focus();
    }
  };

  onInputKeyDown = (event) => {
    const eventKey = event.key;

    if (eventKey === 'Backspace' || eventKey === 'Delete') {
      event.preventDefault();

      const index = Number(event.target.dataset.index);

      event.target.value = '';
      this.currentFocusedValue = '';
      this.verificationCode[index] = '';

      if (index > 0) {
        this.otpItemTargets[index - 1].focus();
        this.otpItemTargets[index - 1].select();
      }
    }
  };

  verifyOtp = (code: string) => {
    this.spinnerTarget.classList.remove('hidden');
    this.otpCodeTarget.value = code;
    this.formTarget.submit();
  };

  generateOtp = () => {
    this.spinnerTarget.classList.remove('hidden');
    this.resendOtpFormTarget.submit();
  };
}
